import { useState } from "react";

const CheckboxItem = ({ label, count, onCheck }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    onCheck(label, count, !isChecked);
  };
  return (
    <div className="flex gap-10 justify-between items-center mt-4 w-full whitespace-nowrap">
      <div className="flex gap-3 items-center self-stretch my-auto leading-none">
        {/* Checkbox */}
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
          className="w-4 h-4 cursor-pointer accent-[#253FF6]"
        />
        {/* Label */}
        <div className="self-stretch my-auto">{label}</div>
      </div>
      {/* Count */}
      <div className="self-stretch my-auto tracking-wide">({count})</div>
    </div>
  );
};

export default CheckboxItem;
